import type { PlanEvent, Task } from "../../../shared/types";
import type { HolidayEntry } from "../../../shared/hooks/use-holidays";
import type { CalendarNavigationState } from "../hooks/use-calendar-navigation";
import { CalendarNavigation } from "./CalendarNavigation";
import { MiniCalendar } from "./MiniCalendar";

type CalendarVariant = "default" | "google";

interface CalendarSidebarProps {
  readonly nav: CalendarNavigationState;
  readonly events: PlanEvent[];
  readonly tasks: Task[];
  readonly onHandleOpenAdd?: () => void;
  readonly variant?: CalendarVariant;
  readonly holidays?: ReadonlyMap<string, HolidayEntry>;
}

export function CalendarSidebar({
  nav,
  events,
  tasks,
  onHandleOpenAdd,
  variant = "default",
  holidays,
}: CalendarSidebarProps) {
  const isGoogle = variant === "google";

  return (
    <aside className={`shrink-0 flex flex-col gap-4 sticky top-4 ${
      isGoogle ? "w-60 py-4 px-3 border-r border-border" : "w-56"
    }`}>
      {!isGoogle && (
        <CalendarNavigation
          currentDate={nav.currentDate}
          selectedDate={nav.currentDate}
          calendarMode={nav.calendarMode}
          onPrev={nav.goToPrev}
          onNext={nav.goToNext}
          onToday={nav.goToToday}
          onGoToDate={nav.goToDate}
          onModeChange={nav.setCalendarMode}
        />
      )}
      {onHandleOpenAdd && !isGoogle && (
        <button
          type="button"
          onClick={onHandleOpenAdd}
          aria-label="Nouvel événement"
          className="h-8 w-full flex items-center justify-center gap-2
            rounded-lg bg-accent text-white hover:opacity-90 active:scale-[0.98]
            focus:outline-none focus:ring-2 focus:ring-accent/50 text-sm font-medium transition-all"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
          Créer
        </button>
      )}
      <MiniCalendar
        events={events}
        tasks={tasks}
        referenceDate={nav.currentDate}
        onSelectDate={nav.goToDate}
        variant={variant}
        holidays={holidays}
      />
    </aside>
  );
}
